/**
 * KaijuLoader - Pixelated Godzilla breathing fire animation for loading states
 * Replaces boring spinners with retro-futurism kaiju power
 */

interface KaijuLoaderProps {
  className?: string
  size?: 'sm' | 'md' | 'lg'
}

const sizeMap = {
  sm: 'scale-75',
  md: 'scale-100',
  lg: 'scale-150',
}

export function KaijuLoader({ className = '', size = 'md' }: KaijuLoaderProps) {
  return (
    <div
      className={`kaiju-loader inline-block ${sizeMap[size]} ${className}`}
      role="status"
      aria-label="Loading"
    >
      <span className="sr-only">Loading...</span>
    </div>
  )
}
